import React from 'react';

const CompactCalendarGrid = ({ currentDate, monthPayments, onDateClick }) => {
  const getDaysInMonth = () => {
    const year = currentDate?.getFullYear();
    const month = currentDate?.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay?.getDate();
    const startingDayOfWeek = firstDay?.getDay();

    const days = [];

    for (let i = 0; i < startingDayOfWeek; i++) {
      days?.push({ isEmpty: true, key: `empty-${i}` });
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      if (!isNaN(date?.getTime())) {
        days?.push({
          date,
          day,
          isEmpty: false,
          key: `day-${day}`
        });
      }
    }

    return days;
  };

  const formatDateKey = (date) => {
    if (!date || isNaN(date?.getTime())) return '';
    const year = date?.getFullYear();
    const month = String(date?.getMonth() + 1)?.padStart(2, '0');
    let day = String(date?.getDate())?.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const isToday = (date) => {
    const today = new Date();
    today?.setHours(0, 0, 0, 0);
    const cellDate = new Date(date);
    cellDate?.setHours(0, 0, 0, 0);
    return cellDate?.getTime() === today?.getTime();
  };

  const days = getDaysInMonth();
  const weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

  return (
    <div className="bg-card rounded-lg border border-border p-8">
      {/* Week day headers */}
      <div className="grid grid-cols-7 gap-4 mb-4">
        {weekDays?.map((day, idx) => (
          <div
            key={`${day}-${idx}`}
            className="text-center text-xs font-medium text-muted-foreground py-4"
          >
            {day}
          </div>
        ))}
      </div>
      
      {/* Calendar days */}
      <div className="grid grid-cols-7 gap-4">
        {days?.map(dayData => {
          if (dayData?.isEmpty) {
            return <div key={dayData?.key} className="aspect-square" />;
          }

          const dateKey = formatDateKey(dayData?.date);
          const payments = monthPayments?.[dateKey] || [];
          const hasPayments = payments?.length > 0;
          const todayFlag = isToday(dayData?.date);

          return (
            <button
              key={dayData?.key}
              onClick={() => onDateClick(dayData?.date)}
              className={`aspect-square p-4 rounded-lg text-xs font-medium transition-all relative ${
                todayFlag
                  ? 'bg-primary/20 text-primary border border-primary/50'
                  : hasPayments
                  ? 'bg-background text-foreground hover:bg-muted border border-border'
                  : 'bg-background text-muted-foreground hover:bg-muted border border-transparent'
              }`}
            >
              <div className="flex flex-col items-center justify-center h-full">
                <span>{dayData?.day}</span>
                {hasPayments && (
                  <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-primary rounded-full" />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CompactCalendarGrid;